import CreateBillingObject from '../Utils/ObjectUtils/CreateBillingObject';
import CreateShippingObject from '../Utils/ObjectUtils/CreateShippingObject';
import GeneratePaymentDetailsObject from '../Utils/ObjectUtils/GeneratePaymentDetailsObject';
import UserPermissionsObject from '../Utils/ObjectUtils/UserPermissionsObject';

function MemberCheckoutAction(
	shippingFormData,
	billingData,
	paymentData,
	brandData,
	userEmail,
	cvv,
	isNewCard,
	paymentMethod,
	cartData,
	addUnlimitedToCart,
	promoCode,
	bumpCode,
	addon,
	couponCode,
	velocityNumber,
	businessPartner,
	receiveEmail
) {
	const {
		address1,
		address2,
		city,
		companyName,
		firstName,
		lastName,
		dayPhoneNumber,
		postalCode,
		salutation,
		state,
		stateCode,
	} = shippingFormData;

	let billingInformation = {
		salutation,
		firstName,
		lastName,
		companyName,
		address1,
		address2,
		dayPhoneNumber,
		city,
		state,
		postalCode,
		stateCode,
	};

	let paymentDetails;

	if (paymentMethod === 'paypal') {
		paymentDetails = [
			{
				billingAddress: CreateBillingObject(
					brandData.country,
					userEmail,
					billingInformation
				),
				type: 'paypalPayment',
			},
		];
	} else {
		paymentDetails = [
			{
				cardId: paymentData.cardId,
				type: 'creditCard',
				cvv,
			},
		];
	}

	if (isNewCard) {
		paymentDetails = [
			GeneratePaymentDetailsObject(
				billingInformation,
				paymentData,
				brandData.country,
				userEmail
			),
		];
	}

	let shippingDetails = [
		CreateShippingObject(
			brandData.country,
			'hardGoodShippingTypeInput',
			userEmail,
			shippingFormData
		),
	];

	let userCheckoutPermissions = UserPermissionsObject(receiveEmail);

	let itemDetails = [];

	if (addon) {
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode: addon?.itemCode,
			},
		];
	} else if (cartData) {
		let itemCode = cartData[0].itemCode;
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode,
			},
		];
	}

	if (addUnlimitedToCart) {
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode: addUnlimitedToCart,
			},
		];
	}

	if (bumpCode) {
		itemDetails = [
			...itemDetails,
			{
				quantity: 1,
				itemCode: bumpCode,
			},
		];
	}

	// if (addon) {
	// 	itemDetails = [
	// 		...itemDetails,
	// 		{
	// 			quantity: 1,
	// 			itemCode: addon?.itemCode,
	// 		},
	// 	];
	// }

	let orderDetails = {
		offerDetails: { responseCode: promoCode },
		itemDetails,
		paymentDetails,
		shippingDetails,
		userCheckoutPermissions,
		userCheckoutPreferences: {
			payViaPaypal: paymentMethod === 'paypal' ? true : false,
			payByVouchersOnly: false,
			saveCreditCard: isNewCard && paymentData.addcardtoprofile,
		},
		webRedirectDetails: {
			commitOrderErrorURL: window.location.href,
			commitOrderSuccessURL: '/jsp/checkout/common/confirmation.jsp?promoCode=',
		},
	};

	// PromoCode, if available
	if (couponCode) {
		let couponDetails = [
			{
				couponCode: couponCode,
			},
		];

		orderDetails = { ...orderDetails, couponDetails };
	}

	// Third Party Number, if available
	if (velocityNumber && businessPartner) {
		let userCheckoutDetails = {
			userBusinessPartner: {
				businessPartner: businessPartner,
				businessPartnerNumber: velocityNumber,
			},
		};

		orderDetails = { ...orderDetails, userCheckoutDetails };
	}

	return orderDetails;
}

export default MemberCheckoutAction;
